<div
  class="accordion"
  [ngClass]="{ 'accordion--collapsible': settings?.isCollapsed }"
>
  <div
    class="accordion__header"
    [ngClass]="{
      'accordion__header--clickable': settings?.isCollapsed,
      'accordion__header--no-border': !settings?.expanded
    }"
    (click)="showContent($event)"
  >
    <div class="accordion__header-wrapper">
      <ng-content select="[header]"></ng-content>
    </div>

    <button class="accordion__button" *ngIf="settings?.isCollapsed">
      <i
        class="fas"
        [ngClass]="{
          'fa-chevron-up': settings?.expanded,
          'fa-chevron-down': !settings?.expanded
        }"
      ></i>
    </button>
  </div>
  <div
    class="accordion__content"
    [ngClass]="{
      'accordion__content--expanded': settings?.expanded,
      'accordion__content--collapsed': !settings?.expanded
    }"
    *ngIf="settings?.expanded"
  >
    <ng-content></ng-content>
  </div>
</div>
